const yuhu = require('../themes/default');

module.exports = { yuhu };
